import { Component, OnInit, Host, Input, AfterViewInit } from '@angular/core';
import { CheckBoxGroupComponent } from '../checkbox-group.component';

@Component({
  selector: 'r-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent extends CheckBoxGroupComponent implements AfterViewInit {



  @Input() value: boolean = false;
  @Input() id: string;
  @Input() label: string;

  constructor() {
    super();
  }
  
  ngAfterViewInit(): void {
    console.log(this.id, this.value, this.label);
  }

  toggleCheck(): void {
    this.addOrRemove(this.value);
    console.log('afsdfas', this.value);
  }

  isChecked() {
    let val = this.contains(this.value);
    console.log(val, this.value);
    return val;
  }
}
